import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const createOffer = createAsyncThunk(
  "offers/create",
  async (offerData) => {
    // Try "offers" (plural) - this is a common REST convention
    const response = await api.post("offers", offerData);
    return response.data;
  }
);

// NOTE: Fetch Offer Details by ID

// api is your axios instance
// export const fetchOfferDetails = createAsyncThunk(
//   "offer/fetchDetails",
//   async (data) => {
//     const { offerId, fields } = data;

//     const params = new URLSearchParams();
//     if (fields?.length) {
//       params.set("fields", fields.join(","));
//     }

//     const url = params.toString()
//       ? `offer/${offerId}?${params.toString()}`
//       : `offer/${offerId}`;

//     const response = await api.get(url);
//     return response.data;
//   }
// );

//payload = {offerId : <offerId>, fields : [] or "field1,field2" or "field1"}
//deafult fields returned -> _id, id,createdAt , title , amount , deadline(UTC) ,
//temporaryDeadline(UTC), workingDaysCount,description,milestones,splitOptions
export const fetchOfferDetails = createAsyncThunk(
  "offer/fetchOfferDetails",
  async (payload) => {
    // Accept either a primitive offerId or an object { offerId, fields }
    let offerId;
    let fields;

    if (payload && typeof payload === "object" && !Array.isArray(payload)) {
      if (payload.offerId !== undefined && payload.offerId !== null) {
        offerId = payload.offerId;
      }
      // allow fields passed either directly or under params
      if (Array.isArray(payload.fields)) {
        fields = payload.fields;
      } else if (typeof payload.fields === "string") {
        fields = payload.fields
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
      }
    } else {
      offerId = payload;
    }
    if (!offerId) {
      throw new Error("offerId is required to fetch offer details");
    }

    const response = await api.get(`offers/${offerId}`, {
      params: {
        fields: fields?.join(","),
      },
    });
    return response.data;
  }
);

// Fetch a list of offers with optional query params (pagination, filters, search, etc.)
export const fetchOffers = createAsyncThunk(
  "offers/fetch",
  async (params = {}) => {
    const response = await api.get("offers", { params });
    return response.data;
  }
);

// Fetch offers for the authenticated user
export const fetchMyOffers = createAsyncThunk(
  "offers/fetchMyOffers",
  async (params = {}) => {
    const response = await api.get("offers/my-offers", { params });
    return response.data;
  }
);

// Update an offer (partial update via PATCH)
// payload should be { id, data }
export const updateOffer = createAsyncThunk(
  "offers/update",
  async (payload) => {
    const { id, data } = payload || {};
    if (!id) throw new Error("offer id is required to update an offer");
    const response = await api.patch(`offers/${id}`, data || {});
    return response.data;
  }
);

// Accept an offer
// payload should be { id, data? }
export const acceptOffer = createAsyncThunk(
  "offers/accept",
  async (payload) => {
    const { id, data } = payload || {};
    if (!id) throw new Error("offer id is required to accept an offer");
    const response = await api.patch(`offers/${id}/accept`, data || {});
    return response.data;
  }
);

// Decline an offer
// payload should be { id, data? }
export const declineOffer = createAsyncThunk(
  "offers/decline",
  async (payload) => {
    const { id, data } = payload || {};
    if (!id) throw new Error("offer id is required to decline an offer");
    const response = await api.patch(`offers/${id}/decline`, data || {});
    return response.data;
  }
);


export const fetchOfferDetailsForCheckout = createAsyncThunk(
  "offer/checkout",
  async (payload) => {
    // Accept either a primitive offerId or an object { offerId, fields }
    let offerId;
    let fields;

    if (payload && typeof payload === "object" && !Array.isArray(payload)) {
      if (payload.offerId !== undefined && payload.offerId !== null) {
        offerId = payload.offerId;
      }
      // allow fields passed either directly or under params
      if (Array.isArray(payload.fields)) {
        fields = payload.fields;
      } else if (typeof payload.fields === "string") {
        fields = payload.fields
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
      }
    } else {
      offerId = payload;
    }
    if (!offerId) {
      throw new Error("offerId is required to fetch offer details");
    }

    const response = await api.get(`offers/checkout/${offerId}`, {
      params: {
        fields: fields?.join(","),
      },
    });
    return response.data;
  }
);

export const getAllOffers = createAsyncThunk(
  "offer/getAllOffers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("offers");
      return response.data;
    } catch (error) {
      console.error("getAllOffers API error:", error);

      // Return a more helpful error message
      if (error.response?.status === 404) {
        return rejectWithValue(
          "Offers endpoint not found. Please check your backend."
        );
      } else if (error.response?.status >= 500) {
        return rejectWithValue("Server error. Please try again later.");
      } else if (error.message === "Network Error") {
        return rejectWithValue("Network error. Please check your connection.");
      } else {
        return rejectWithValue(
          error.response?.data?.message ||
            error.message ||
            "Failed to fetch offers"
        );
      }
    }
  }
);

// Fetch My Offers (created by current logged-in user)
export const getMyOffers = createAsyncThunk(
  "offer/getMyOffers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("offers/my-offers");
      return response.data;
    } catch (error) {
      console.error("getMyOffers API error:", error);

      // Return a more helpful error message
      if (error.response?.status === 404) {
        return rejectWithValue(
          "My offers endpoint not found. Please check your backend."
        );
      } else if (error.response?.status >= 500) {
        return rejectWithValue("Server error. Please try again later.");
      } else if (error.message === "Network Error") {
        return rejectWithValue("Network error. Please check your connection.");
      } else {
        return rejectWithValue(
          error.response?.data?.message ||
            error.message ||
            "Failed to fetch my offers"
        );
      }
    }
  }
);

// NOTE: Fetch Offer Details by ID

// api is your axios instance

